// @ts-nocheck
import { Link, navigate, RouteComponentProps } from "@reach/router"
// Styles
import { RecoveryPools_s } from "components/recoveries/recovery-pools/detail/recovery-pools-detail-styles"
import RecoveryPoolsDetailTable from "components/recoveries/recovery-pools/detail/recovery-pools-detail-table"
// Components
import { Toolbar } from "components/subnav"
import { DetailedRouteUpDown_s, DetailedUpDownBtn_s } from "components/table/data-table-styles"
import { HeaderIcon_s } from 'components/wrapper/header/header-styles'
// Data
import api_match from "data/interface/api"
import keyService, * as chord from "data/key"
import lineItemsService from "data/line-items"
import propertyService from 'data/property.ts'
import recoveryPoolsService from "data/recovery-pools"
import tenantContributionsService from 'data/tenant-contributions'
// Icons
import { BackArrowIcon, CaretRightIcon } from 'images/icons/general/'
import { CaretDownIcon, CaretUpIcon } from "images/icons/tools/"
import _ from 'lodash'
import React, { FC, useEffect, useState } from 'react'
import Isvg from 'react-inlinesvg'

const RecoveryPoolsDetail: FC<RouteComponentProps> = (props) => {
  const [currentRecoveryPool, setCurrentRecoveryPool] = useState<object | null>(null)
  const [recoveryPools, setRecoveryPools] = useState<object[] | null>(null);
  const [tenantContributions, setTenantContributions] = useState<object[] | { message: string }>([])
  const [lineItems, setLineItems] = useState<object[] | { message: string }>([])
  const [property, setProperty] = useState<object|null>(null)
  const [propertyId, setPropertyId] = useState(propertyService.getStoredPropertyId())
  const [hasSelectedItems, setHasSelectedItems] = useState<boolean>(false)
  const [selectedItemsInit, setSelectedItemsInit] = useState<boolean>(false)
  const tableId = "recovery-pools-detail-table"

  useEffect(() => {
    const propertySubscription = propertyService.stream().subscribe((data) => {
      if (data.value.length > 0){
        let property = _.find(data.value, {propertyid: data.current})
        if(property && propertyId !== property.propertyid) {
          navigate('/n/recoveries/recovery-pools')
        } else {
          setProperty(property)
        }
      }
    })

    const recoveryPoolsSubscription = recoveryPoolsService.stream().subscribe(data => {
      api_match(
        data,
        init  => {},
        ok    => {
          if (data.value.length){
            const currentPool = _.find(data.value, pool => pool.recoverypoolid === _.toNumber(_.get(props, "recoveryPoolId")))
            if(!selectedItemsInit) {
              let hasSelectedItems = currentPool?.recoverypooldetail?.expenseItems?.lineItems?.length || currentPool?.recoverypooldetail?.tenantContributionItems?.items?.length
              setHasSelectedItems(hasSelectedItems)
              setSelectedItemsInit(true)
            }
          }
          setRecoveryPools(data.value)
          aggregatePoolData()
        },
        err   => {},
        fetch => {}
      )
    })

    recoveryPoolsService.fetchRecoveryPools(propertyId)

    return function cleanup() {
      recoveryPoolsSubscription.unsubscribe()
      propertySubscription.unsubscribe()
    }
  }, [selectedItemsInit, hasSelectedItems])

  useEffect(() => {
    const keySubscription = keyService.stream().subscribe(k => {
      switch(true) {
        case k.chord === chord.CTRL_SHIFT_UP && k.down === true:
          toggleRecoveryPool('up')
          break
        case k.chord === chord.CTRL_SHIFT_DOWN && k.down === true:
          toggleRecoveryPool('down')
          break
        case k.chord === chord.CTRL_SHIFT_BACK && k.down === true:
          navigate('/n/recoveries/recovery-pools')
      }
    })

    return function cleanup() {
      keySubscription.unsubscribe()
    }
  })

  useEffect(() => {
    if (_.isNil(propertyId)) return
    propertyService.fetchProperty(propertyId)
    recoveryPoolsService.fetchRecoveryPools(propertyId)
  }, [propertyId])

  const aggregatePoolData = () => {
    Promise.all([
      tenantContributionsService.fetchTenantContributions(propertyId),
      lineItemsService.fetchLineItemsByType(propertyId, "expense")
    ]).then(([tenantContributions, lineItems]) => {
      setTenantContributions(tenantContributions)
      setLineItems(lineItems)
    })
  }

  function toggleRecoveryPool(direction:string):void {
    const currentPool                  = currentRecoveryPool && _.find(recoveryPools, pool => pool.recoverypoolid === currentRecoveryPool.recoverypoolid) || _.find(recoveryPools, pool => pool.recoverypoolid === _.toNumber(_.get(props, "recoveryPoolId")))
    const currentPortfolioIdx          = recoveryPools?.indexOf(currentPool!);
    let   nextRecoveryPool:object|null = null
    if (direction === 'up' && recoveryPools){
      nextRecoveryPool = recoveryPools && recoveryPools[currentPortfolioIdx! - 1]
    } else {
      nextRecoveryPool = recoveryPools && recoveryPools[currentPortfolioIdx! + 1]
    }
    if (nextRecoveryPool) setCurrentRecoveryPool(nextRecoveryPool)
  }

  let currentPool =  currentRecoveryPool && _.find(recoveryPools, pool => pool.recoverypoolid === currentRecoveryPool.recoverypoolid) || _.find(recoveryPools, pool => pool.recoverypoolid === _.toNumber(_.get(props, "recoveryPoolId")))
  
  const upDisabled   = !recoveryPools || _.isNil(recoveryPools[recoveryPools.indexOf(currentPool!) - 1]) || (!_.isNil(recoveryPools) && currentPool && recoveryPools[recoveryPools.indexOf(currentPool!) - 1]['systeminput']?.startsWith('system'))
  const downDisabled = !recoveryPools || _.isNil(recoveryPools[recoveryPools.indexOf(currentPool!) + 1]) || (!_.isNil(recoveryPools) && currentPool && recoveryPools[recoveryPools.indexOf(currentPool!) + 1]['systeminput']?.startsWith('system'))

  return (
    <RecoveryPools_s>
      <Toolbar>
        {currentPool &&
          <div>
            <Link to="/n/recoveries/recovery-pools">
              <HeaderIcon_s style={{marginRight: '5px'}}><Isvg src={BackArrowIcon} /></HeaderIcon_s>
              Recovery Pools
            </Link>
            <HeaderIcon_s style={{marginRight: '5px'}}><Isvg src={CaretRightIcon} /></HeaderIcon_s>
            <div>Details</div>
            <DetailedRouteUpDown_s>
              <DetailedUpDownBtn_s id="detailedRouteRecordUp" disabled={upDisabled} onClick={()=>toggleRecoveryPool('up')}><Isvg src={CaretUpIcon} /></DetailedUpDownBtn_s>
              <DetailedUpDownBtn_s id="detailedRouteRecordDown" disabled={downDisabled} onClick={()=>toggleRecoveryPool('down')}><Isvg src={CaretDownIcon} /></DetailedUpDownBtn_s>
            </DetailedRouteUpDown_s>
            <div>{_.get(currentPool, "code")}</div>
          </div>
        }
      </Toolbar>
      { currentPool ?
        <RecoveryPoolsDetailTable
          tableId={tableId}
          recoveryPool={currentPool}
          lineItems={lineItems}
          tenantContributions={tenantContributions}
          hasSelectedItems={hasSelectedItems} />
        :
        null
      }
    </RecoveryPools_s>
  )
}

export default RecoveryPoolsDetail
